module.exports = __webpack_public_path__ + "img/w6-b4.2afd34e6.jpg";